module.exports = "<span class=\"bold\" *ngIf=\"title\">{{ title }}</span>\n<ng-content></ng-content>"